const Containers = async (_, args, context, info) => {
  const {
    userId,
    maxNumberOfResults,
    principalId,
    siteId,
    sessionId
  } = args;
  return await context.fetch(`${context.url.collaborationGraph}/v1/collaborationgraph/user/container`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      context: {
        contextType: 'atlassianDirectory',
        principalId,
        siteId,
        sessionId
      },
      containerTypes: ['confluenceSpace', 'jiraProject'],
      maxNumberOfResults,
      userId,
      expanded: true
    })
  }).then(res => {
    // Matches type of QueryData['Containers'] in
    // packages/embeddable-directory/src/components/CGContainers/ContainersQuery.tsx
    return res.json();
  });
};
export default Containers;